<script setup>
import { ref } from 'vue'
import Card from '../global/Card.vue'

const cards = ref([
    {
        title: 'Online Tournaments',
        subtitle: 'High-stakes tournaments with cash and Logitech G prizes on the line. Test your skills with a new game each season.'
    },
    {
        title: 'Community Game Nights',
        subtitle: 'Join Community Game Nights to enjoy casual games, make new friends, and win great Logitech G prizes!'
    }
])
</script>

<template>
    <section class="lg:py-28 py-12 bg-[#121216] text-white">
        <div class="container">
            <h2 class="lg:text-5xl text-4xl uppercase font-bold text-center lg:mb-16 mb-8 accent-text">Two Ways To Play</h2>
            <div class="grid grid-cols-12 gap-6">
                <div class="lg:col-span-10 col-span-12 lg:col-start-2 grid lg:grid-cols-2 gap-6">
                    <Card v-for="card, i in cards" :key="i">
                        <div class="flex flex-col gap-6 text-center">
                            <h3 class="lg:text-3xl sm:text-2xl text-xl font-bold uppercase">{{ card.title }}</h3>
                            <p class="leading-relaxed opacity-75">{{ card.subtitle }}</p>
                        </div>
                    </Card>
                </div>
            </div>
        </div>
    </section>
</template>
